import { render, staticRenderFns } from "./StartForm1.vue?vue&type=template&id=52eb225a"
import script from "./StartForm1.vue?vue&type=script&lang=ts"
export * from "./StartForm1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports